module.exports = __webpack_public_path__ + "img/Company-Alignment@2x.ccf8167e.png";